import React from 'react';

// Backend availability uses local Kigali dates and times.
export function dailyWindows(slots = []) {
  return slots.flatMap(slot => {
    const rows = [];
    const lastDay = slot.endsAt.slice(0, 10);
    let day = slot.startsAt.slice(0, 10);
    while (day <= lastDay) {
      const from = day === slot.startsAt.slice(0, 10) ? slot.startsAt.slice(11, 16) : '00:00';
      const until = day === lastDay ? slot.endsAt.slice(11, 16) : '24:00';
      if (from !== until) rows.push({ day, from, until });
      const next = new Date(`${day}T00:00:00Z`);
      next.setUTCDate(next.getUTCDate() + 1);
      day = next.toISOString().slice(0, 10);
    }
    return rows;
  });
}
export function mergeTimeWindows(windows) {
  const merged = [];
  [...windows].sort((a, b) => a.from.localeCompare(b.from) || a.until.localeCompare(b.until)).forEach(window => {
    const previous = merged[merged.length - 1];
    if (previous && window.from <= previous.until) {
      if (window.until > previous.until) previous.until = window.until;
    } else merged.push({ from: window.from, until: window.until });
  });
  return merged;
}
export default function AvailabilityWindows({ slots = [], showDates = false }) {
  const rows = dailyWindows(slots);
  const groups = new Map();
  rows.forEach(row => {
    const label = new Date(`${row.day}T12:00:00+02:00`).toLocaleDateString('en-GB', {
      timeZone: 'Africa/Kigali', weekday: 'long', ...(showDates ? { day: 'numeric', month: 'short', year: 'numeric' } : {}),
    });
    if (!groups.has(label)) groups.set(label, []);
    groups.get(label).push(row);
  });
  return groups.size ? <ul className="divide-y divide-orange-100 rounded-lg border border-orange-200 bg-orange-50 px-4">{Array.from(groups, ([label, times]) => <li key={label} className="py-3 flex flex-wrap justify-between gap-2 text-sm">
    <span className="font-semibold">{label}</span>
    <span>{mergeTimeWindows(times).map(time => `${time.from} – ${time.until}`).join(' · ')}</span>
  </li>)}</ul> : <p>No upcoming availability. Please check back later.</p>;
}
